/**
 * Where the get-started flow keeps a half-finished run so a refresh doesn't
 * lose the customer's place.
 *
 * Split into its own module so the site nav can clear the session without
 * importing GetStartedFlow — the nav renders on every marketing page, and
 * pulling the whole flow (and every step under it) into that bundle for one
 * string would be a poor trade.
 *
 * Session-scoped, matching lib/chat/nudges.ts: resuming within a visit is
 * useful, resurrecting a package from days ago is not.
 */
export const GET_STARTED_STORAGE_KEY = "mutetaxes.get-started";

/** Bumped when the persisted shape changes, so old blobs are discarded. */
export const GET_STARTED_STORAGE_VERSION = 1;

// Merely reading the property throws when storage access is blocked, so even
// the lookup needs guarding.
export const readGetStartedStorage = (): Storage | null => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

/**
 * Drops the saved run. Called when someone deliberately re-enters the flow —
 * "Get started" means start over, not resume.
 */
export const clearGetStartedSession = (): void => {
  try {
    readGetStartedStorage()?.removeItem(GET_STARTED_STORAGE_KEY);
  } catch {
    // Nothing to do: a session we can't clear is one we couldn't have saved.
  }
};
